<template>
  <div class="nav-compoment">
    <van-sticky>
      <van-nav-bar
        class="nav"
        :title="displayTitle"
        :left-text="leftText"
        :left-arrow="leftArrow"
        safe-area-inset-top
        @click-left="onClickLeft"
      >
        <template #right>
          <slot />
        </template>
      </van-nav-bar>
    </van-sticky>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '请输入标题'
    },
    leftText: {
      type: String,
      default: '返回'
    },
    leftArrow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // 在小程序环境下隐藏标题
    displayTitle() {
      // 优先使用 window.env.isWechatMiniProgram（由 bridge.js 在应用启动时设置）
      if (window.env && window.env.isWechatMiniProgram === true) {
        return ''
      }
      // 备用方案：直接检查 __wxjs_environment
      if (window.__wxjs_environment === 'miniprogram') {
        return ''
      }
      return this.title
    }
  },
  methods: {
    onClickLeft() {
      // if (this.$route.name === 'OrderList') {
      //   this.$router.push({ 'name': 'User' })
      // } else {
      //   this.$router.go(-1)
      // }
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" >
@import "@/styles/variables.scss";

// reset vant-nav-bar style
.nav-compoment {
  .van-nav-bar {
    .van-icon {
      color: $black;
    }
    .van-nav-bar__text {
      color: $black;
    }
  }
}
</style>
